import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initWebVitals } from "./lib/webVitals";

(function () {
  if (typeof window === "undefined") return;
  const w = window as any;
  function g() {
    w.dataLayer = w.dataLayer || [];
    if (!w.gtag) {
      w.gtag = function () {
        w.dataLayer.push(arguments);
      };
    }
    return w.gtag;
  }
  function norm(p: string) {
    const d = (p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return "";
  }
  document.addEventListener(
    "submit",
    function (e) {
      try {
        const f = e.target as HTMLFormElement;
        if (!f || !f.querySelector) return;
        const ph = f.querySelector(
          "input[type=tel],input[name*=phone i],input[placeholder*=phone i]",
        ) as HTMLInputElement | null;
        const em = f.querySelector(
          "input[type=email],input[name*=email i],input[placeholder*=email i]",
        ) as HTMLInputElement | null;
        const nm = f.querySelector("input[name*=name i],input[placeholder*=name i]") as HTMLInputElement | null;
        const ud: any = {};
        const p = norm(ph ? ph.value : "");
        if (p) ud.phone_number = p;
        if (em && em.value) ud.email = em.value.trim().toLowerCase();
        if (nm && nm.value && nm.value.trim()) {
          const parts = nm.value.trim().split(/\s+/);
          ud.address = { first_name: parts[0], country: "CA" };
          if (parts.length > 1) ud.address.last_name = parts.slice(1).join(" ");
        }
        if (ud.phone_number || ud.email) {
          g()("set", "user_data", ud);
          try {
            sessionStorage.setItem("tron_ud", JSON.stringify(ud));
          } catch (x) {}
        }
      } catch (x) {}
    },
    true,
  );
  try {
    const s = sessionStorage.getItem("tron_ud");
    if (s) {
      g()("set", "user_data", JSON.parse(s));
    }
  } catch (x) {}
})();

const rootEl = document.getElementById("root")!;

// Pages ship with their full text pre-rendered into #root (for Google and AI
// tools). Keep that copy on screen while the app loads, then swap it out once
// the live page has rendered its heading, so visitors never see a blank gap.
if (rootEl.dataset.prerendered) {
  const snapshot = document.createElement("div");
  snapshot.innerHTML = rootEl.innerHTML;
  snapshot.setAttribute("aria-hidden", "true");
  rootEl.innerHTML = "";
  rootEl.style.display = "none";
  rootEl.parentNode!.insertBefore(snapshot, rootEl);
  const reveal = () => {
    observer.disconnect();
    snapshot.remove();
    rootEl.style.display = "";
  };
  const observer = new MutationObserver(() => {
    if (rootEl.querySelector("h1") && !rootEl.querySelector('[aria-busy="true"]')) reveal();
  });
  observer.observe(rootEl, { childList: true, subtree: true });
  setTimeout(reveal, 5000);
}

createRoot(rootEl).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

// Real-user performance monitoring: measures Core Web Vitals on visitor devices
// and raises `perf_alert` in GTM when a page misses its mobile/desktop budget.
initWebVitals();
